import React, { useState } from 'react'
import "./NavbarMobileView.css"
import { GiHamburgerMenu } from "react-icons/gi"
import { FcHome, FcNightPortrait, FcTodoList, FcRules, FcContacts, FcFactory, FcSalesPerformance } from "react-icons/fc";
import { Link } from "react-scroll"
import { MdBiotech, MdCastForEducation } from "react-icons/md";
import Switch from "react-switch";


function NavbarMobileView({ theme, changeTheme }) {


  const [open, setOpen] = useState(false)

  const handleClick = () => {
    setOpen(!open)
  }

  return (
    <div className='mobile-view-navbar'>
      <div className="nav-bar-header">
        <p><GiHamburgerMenu size={25} onClick={handleClick} /></p>
      </div>

      {open ? (<div className="mobile-nav">
        <ul>
          <li className='nav-item-mobile-view'>
            <Link
              to='home'
              spy={true}
              smooth={true}
              duration={100}
              offset={-100}
            >
              <FcHome size={20} />
              Home </Link> </li>
          <li className='nav-item-mobile-view'>
            <Link

              to='about'
              spy={true}
              smooth={true}
              duration={100}
              offset={-100}
            >
              <FcNightPortrait size={20} /> About
            </Link>
          </li>
          <li className='nav-item-mobile-view'>

            <Link
              to='techStack'
              spy={true}
              smooth={true}
              duration={100}
              offset={-100}
            >
              <MdBiotech size={20} />Tech Stack
            </Link>

          </li>
          <li className='nav-item-mobile-view'>
            <Link

              to='project'
              spy={true}
              smooth={true}
              duration={100}
              offset={-100}
            >
              <FcTodoList size={20} /> Porjects
            </Link>

          </li>
          <li className='nav-item-mobile-view'>

            <Link

              to='expriance'
              spy={true}
              smooth={true}
              duration={100}
              offset={-100}
            >
              <FcFactory size={20} /> Experiance
            </Link>

          </li>
          <li className='nav-item-mobile-view'>

            <Link
              to='education'
              spy={true}
              smooth={true}
              duration={100}
              offset={-100}
            >
              <MdCastForEducation size={20} /> Education
            </Link>


          </li>
          <li className='nav-item-mobile-view'>

            <Link
              to='testimonial'
              spy={true}
              smooth={true}
              duration={100}
              offset={-100}
            >
              <FcRules size={20} /> Testmonial
            </Link>


          </li>
          <li className='nav-item-mobile-view'>

            <Link
              to='contactid'
              spy={true}
              smooth={true}
              duration={100}
              offset={-100}
            >
              <FcContacts size={20} /> Contact
            </Link>

          </li>

          <li className='nav-item-mobile-view'>
            <Switch onChange={changeTheme} checked={theme ==="light"} />
          </li>


        </ul>
      </div>) : null}


    </div>
  )
}

export default NavbarMobileView